//#region react import
import { useSelector } from "react-redux";
//#endregion

//#region functions import
import { getTranslations } from "../TranslationController";
//#endregion

//#region constants import
import {
  CENTER_FORMATIONS,
  CENTER_SETTINGS,
  CENTER_SIMULATORS,
  CUSTOM_FIELDS,
  SELECT_ACTIVE_CENTER,
} from "../../Routing/PageNames";
//#endregion

const DataMenu = () => {
  //#region useSelector
  const translations = useSelector((state) => state.translationSlice.translations);
  const trainer = useSelector((state) => state.connexionSlice.trainer);
  //#endregion

  //#region functions
  const buildDataMenu = () => {
    const isLocal = process.env.REACT_APP_LOCAL;
    const isMobileCenter = trainer.activeCenter.centerMobile;

    const menu = [];

    if (!isLocal) {
      menu.push(SELECT_ACTIVE_CENTER);
    }

    menu.push(CENTER_SIMULATORS, CUSTOM_FIELDS);

    if (isMobileCenter) {
      menu.push(CENTER_FORMATIONS);
    }

    menu.push(CENTER_SETTINGS);

    return menu.map((item, index) => ({
      id: index + 1,
      url: item.url,
      title: getTranslations(item.pageTraductionKey, translations),
    }));
  };
  //#endregion

  return buildDataMenu();
};

export default DataMenu;
